module.exports = __webpack_public_path__ + "static/img/jsnh.f9065de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/jsnh.png
// module id = luGR
// module chunks = 0